/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personUpdateDataSchema = z.object({
	name: z.string().nullable().optional(),
	phone: z.string().nullable().optional(),
})

export type PersonUpdateDataSchema = z.infer<typeof personUpdateDataSchema>
